<div class="free-text-output" #textWrapper>
  <div class="free-text-wrap">
    @if (canRenderQuill) {
      <div class="quill-wrap" [style.display]="quillContentBig ? 'block' : ''"
        [class.overflowed]="quillContentShown">
        <quill-view [content]="content" format="json" theme="snow" (onEditorCreated)="calculateHeight()"></quill-view>
      </div>
    }
  </div>
  @if (quillContentBig) {
    <div class="free-text-overflowed" (click)="openReferenceModal($event)">See more</div>
  }
</div>
